import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8a86f3b6")

_pushScopeId("data-v-8a86f3b6")
const _hoisted_1 = { class: "employee-header" }
const _hoisted_2 = { class: "d-grid d-lg-none mobile-tab-switcher" }
const _hoisted_3 = { class: "employee-filter" }
const _hoisted_4 = { class: "employee-filter-desktop d-none d-lg-flex" }
const _hoisted_5 = { class: "employee-filter-desktop-template" }
const _hoisted_6 = { class: "employee-filter-desktop-first-row" }
const _hoisted_7 = { class: "employee-filter-desktop-second-row" }
const _hoisted_8 = { class: "employees-body-template" }
const _hoisted_9 = { class: "available-employee-block" }
const _hoisted_10 = { class: "employees-body-title" }
const _hoisted_11 = { class: "available-employee-table employee-table" }
const _hoisted_12 = { class: "employee-table-header available-employee-table-row-template" }
const _hoisted_13 = { class: "employee-row-action" }
const _hoisted_14 = { class: "employee-table-rows-template" }
const _hoisted_15 = { class: "available-employee-table-rows employee-table-rows-height" }
const _hoisted_16 = { class: "single-ellipsis" }
const _hoisted_17 = { class: "employee-phone single-ellipsis" }
const _hoisted_18 = { class: "justify-self-end" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "icon-f icon-plus-circle fs-20" }, null, -1)
const _hoisted_20 = { class: "assigned-employee-block" }
const _hoisted_21 = { class: "employees-body-title" }
const _hoisted_22 = { class: "assigned-employee-table employee-table" }
const _hoisted_23 = { class: "employee-table-header assigned-employee-table-row-template" }
const _hoisted_24 = { class: "employee-row-action" }
const _hoisted_25 = { class: "employee-table-rows-template" }
const _hoisted_26 = { class: "assigned-employee-table-rows employee-table-rows-height" }
const _hoisted_27 = { class: "single-ellipsis" }
const _hoisted_28 = { class: "employee-phone single-ellipsis" }
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-remove-circle pr4" }, null, -1)
const _hoisted_30 = { class: "employees-body-mobile-template" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "employee-filter-mobile" }
const _hoisted_33 = { class: "employee-filter-mobile-first-row" }
const _hoisted_34 = { class: "employee-filter-mobile-second-row" }
const _hoisted_35 = { class: "mobile-checkbox-row" }
const _hoisted_36 = { class: "checkbox-wrapper" }
const _hoisted_37 = {
  class: "cbx same-size w-100 mobile-employee-filter-checkbox",
  for: "onlyAvailable"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_39 = { class: "checkboxtext" }
const _hoisted_40 = { class: "mobile-checkbox-row" }
const _hoisted_41 = { class: "checkbox-wrapper" }
const _hoisted_42 = {
  class: "cbx same-size w-100 mobile-employee-filter-checkbox",
  for: "noAssignmentsCurrentMonth"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_44 = { class: "checkboxtext" }
const _hoisted_45 = {
  key: 0,
  class: "mobile-checkbox-row"
}
const _hoisted_46 = { class: "checkbox-wrapper" }
const _hoisted_47 = {
  class: "cbx same-size w-100 mobile-employee-filter-checkbox",
  for: "assignedOrderSlots"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10"
  }, [
    /*#__PURE__*/_createVNode("polyline", { points: "1.5 6 4.5 9 10.5 1" })
  ])
], -1)
const _hoisted_49 = { class: "checkboxtext" }
const _hoisted_50 = { class: "available-employee-mobile-table-rows" }
const _hoisted_51 = { class: "assigned-mobile-row" }
const _hoisted_52 = { class: "assigned-title after-colon" }
const _hoisted_53 = { class: "single-ellipsis assigned-value" }
const _hoisted_54 = { class: "assigned-mobile-row" }
const _hoisted_55 = { class: "assigned-title after-colon" }
const _hoisted_56 = { class: "assigned-value employee-phone employee-phone-mobile single-ellipsis" }
const _hoisted_57 = { class: "assigned-mobile-row pb-2" }
const _hoisted_58 = { class: "assigned-title after-colon" }
const _hoisted_59 = { class: "assigned-value" }
const _hoisted_60 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_61 = /*#__PURE__*/_createVNode("div", { class: "icon-f icon-plus-circle fs-20" }, null, -1)
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "mobile-assigned-employee-body-rows" }
const _hoisted_64 = { class: "assigned-mobile-row" }
const _hoisted_65 = { class: "assigned-title after-colon" }
const _hoisted_66 = { class: "single-ellipsis assigned-value" }
const _hoisted_67 = { class: "assigned-mobile-row" }
const _hoisted_68 = { class: "assigned-title after-colon" }
const _hoisted_69 = { class: "assigned-value employee-phone employee-phone-mobile single-ellipsis" }
const _hoisted_70 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_71 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-remove-circle pr4" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckBoxInput = _resolveComponent("CheckBoxInput")
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[14] || (_cache[14] = ($event: any) => (_ctx.isOpen = $event)),
    contentClass: "modal-limit employee-modal",
    modalWidth: 1276
  }, {
    default: _withId(() => [
      _createVNode("div", {
        class: ["employee-modal-template", { byOrder: _ctx.byOrder, 'view-mode': _ctx.isViewMode }]
      }, [
        _createVNode("div", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.byOrder == true
                        ? _ctx.$t('calendar.tooltip.employee')
                        : _ctx.productName + ' ' + _ctx.formatLocalDateTimeIsrael(_ctx.startDate + ' ' + _ctx.slot.startTime)) + " ", 1),
          _createVNode("span", {
            class: "icon-f icon-delete-cross fs-16",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
          })
        ]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTab(1))),
            class: { 'selected-tab': _ctx.selectedTab === 1 }
          }, _toDisplayString(_ctx.$t('label.available-employees')), 3),
          _createVNode("div", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectTab(2))),
            class: { 'selected-tab': _ctx.selectedTab === 2 }
          }, _toDisplayString(_ctx.$t('label.assigned-employees')), 3)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _withDirectives(_createVNode("input", {
                  class: "bookit-input order-input w100",
                  id: "datetime",
                  type: "text",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.keywords = $event)),
                  placeholder: _ctx.$t('placeholder.search-name-tags')
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.filter.keywords]
                ]),
                _createVNode("div", null, [
                  _createVNode("span", {
                    class: "show-all-assign-employees",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
                  }, _toDisplayString(_ctx.$t('button.showAll')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_CheckBoxInput, {
                  class: "no-assignments",
                  modelValue: _ctx.filter.noAssignmentsCurrentMonth,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter.noAssignmentsCurrentMonth = $event)),
                  singleLine: true,
                  label: _ctx.$t('label.no-assignments-current-month')
                }, null, 8, ["modelValue", "label"]),
                _createVNode(_component_CheckBoxInput, {
                  modelValue: _ctx.filter.onlyAvailable,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filter.onlyAvailable = $event)),
                  singleLine: true,
                  label: _ctx.$t('label.only-available-employees')
                }, null, 8, ["modelValue", "label"]),
                (_ctx.byOrder)
                  ? (_openBlock(), _createBlock(_component_CheckBoxInput, {
                      key: 0,
                      class: "no-assignments",
                      modelValue: _ctx.filter.assignedOrderSlots,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.filter.assignedOrderSlots = $event)),
                      singleLine: true,
                      label: _ctx.$t('label.assigned-order-slot')
                    }, null, 8, ["modelValue", "label"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('label.available-employees')) + ":", 1),
            _createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", null, _toDisplayString(_ctx.$t('employees.full-name')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.$t('label.mobile')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.$t('label.qty-slot-last-month')), 1),
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('label.assign')), 1)
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode(_TransitionGroup, {
                    name: _ctx.durationName,
                    tag: "p"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableEmployees, (available) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "employee-table-row employee-table-row available-employee-table-row-template",
                          key: available.id
                        }, [
                          _createVNode("div", _hoisted_16, _toDisplayString(available.firstName) + " " + _toDisplayString(available.lastName), 1),
                          _createVNode("div", _hoisted_17, [
                            (available.mobile)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: `tel:${available.mobile}`
                                }, _toDisplayString(_ctx.formatMobile(available.mobile)), 9, ["href"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("div", null, _toDisplayString(available.qtySlotsLastMonth), 1),
                          _createVNode("div", _hoisted_18, [
                            _createVNode("button", {
                              onClick: ($event: any) => (_ctx.assignEmployee(available.id)),
                              class: "assign-btn",
                              type: "button"
                            }, [
                              _hoisted_19,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('label.assign')), 1)
                            ], 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["name"])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('label.assigned-employees')) + ":", 1),
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createVNode("div", null, _toDisplayString(_ctx.$t('employees.full-name')), 1),
                _createVNode("div", null, _toDisplayString(_ctx.$t('label.mobile')), 1),
                _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('button.remove')), 1)
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode("div", _hoisted_26, [
                  _createVNode(_TransitionGroup, {
                    name: _ctx.durationName,
                    tag: "p"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.assignedEmployees, (assigned) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "employee-table-row employee-table-row assigned-employee-table-row-template",
                          key: assigned.id
                        }, [
                          _createVNode("div", _hoisted_27, _toDisplayString(assigned.fullName), 1),
                          _createVNode("div", _hoisted_28, [
                            (assigned.mobile)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 0,
                                  href: `tel:${assigned.mobile}`
                                }, _toDisplayString(_ctx.formatMobile(assigned.mobile)), 9, ["href"]))
                              : _createCommentVNode("", true)
                          ]),
                          (!_ctx.isViewMode)
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.unassignEmployee(assigned.id)),
                                class: "justify-self-center"
                              }, [
                                _hoisted_29
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["name"])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_30, [
          (_ctx.selectedTab === 1)
            ? (_openBlock(), _createBlock("div", _hoisted_31, [
                _createVNode("div", _hoisted_32, [
                  _createVNode("div", _hoisted_33, [
                    _createVNode("div", null, [
                      _withDirectives(_createVNode("input", {
                        class: "bookit-input w100 mobile-filter-employee-keywords",
                        id: "datetime",
                        type: "text",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.filter.keywords = $event)),
                        placeholder: _ctx.$t('placeholder.search-name-tags')
                      }, null, 8, ["placeholder"]), [
                        [_vModelText, _ctx.filter.keywords]
                      ])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("span", {
                        class: "show-all-assign-employees",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
                      }, _toDisplayString(_ctx.$t('button.showAll')), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_34, [
                    _createVNode("div", _hoisted_35, [
                      _createVNode("span", _hoisted_36, [
                        _withDirectives(_createVNode("input", {
                          class: "inp-cbx",
                          id: "onlyAvailable",
                          type: "checkbox",
                          style: {"display":"none"},
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.filter.onlyAvailable = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.filter.onlyAvailable]
                        ]),
                        _createVNode("label", _hoisted_37, [
                          _hoisted_38,
                          _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t('label.only-available-employees')), 1)
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_40, [
                      _createVNode("span", _hoisted_41, [
                        _withDirectives(_createVNode("input", {
                          class: "inp-cbx",
                          id: "noAssignmentsCurrentMonth",
                          type: "checkbox",
                          style: {"display":"none"},
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.filter.noAssignmentsCurrentMonth = $event))
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.filter.noAssignmentsCurrentMonth]
                        ]),
                        _createVNode("label", _hoisted_42, [
                          _hoisted_43,
                          _createVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('label.no-assignments-current-month')), 1)
                        ])
                      ])
                    ]),
                    (_ctx.byOrder)
                      ? (_openBlock(), _createBlock("div", _hoisted_45, [
                          _createVNode("span", _hoisted_46, [
                            _withDirectives(_createVNode("input", {
                              class: "inp-cbx",
                              id: "assignedOrderSlots",
                              type: "checkbox",
                              style: {"display":"none"},
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.filter.assignedOrderSlots = $event))
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.filter.assignedOrderSlots]
                            ]),
                            _createVNode("label", _hoisted_47, [
                              _hoisted_48,
                              _createVNode("span", _hoisted_49, _toDisplayString(_ctx.$t('label.assigned-order-slot')), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_50, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.availableEmployees, (available) => {
                    return (_openBlock(), _createBlock("div", {
                      key: available.id,
                      class: "assigned-employee-mobile-table-row"
                    }, [
                      _createVNode("div", _hoisted_51, [
                        _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t('employees.full-name')), 1),
                        _createVNode("div", _hoisted_53, _toDisplayString(available.fullName), 1)
                      ]),
                      _createVNode("div", _hoisted_54, [
                        _createVNode("div", _hoisted_55, _toDisplayString(_ctx.$t('label.mobile')), 1),
                        _createVNode("div", _hoisted_56, [
                          (available.mobile)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: `tel:${available.mobile}`
                              }, _toDisplayString(_ctx.formatMobile(available.mobile)), 9, ["href"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("div", _hoisted_57, [
                        _createVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('label.qty-slot-last-month')), 1),
                        _createVNode("div", _hoisted_59, [
                          _createVNode("span", null, _toDisplayString(available.qtySlotsLastMonth), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_60, [
                        _createVNode("button", {
                          onClick: ($event: any) => (_ctx.assignEmployee(available.id)),
                          class: "assign-btn",
                          type: "button"
                        }, [
                          _hoisted_61,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('label.assign')), 1)
                        ], 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_62, [
                _createVNode("div", _hoisted_63, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.assignedEmployees, (assigned) => {
                    return (_openBlock(), _createBlock("div", {
                      key: assigned.id,
                      class: "mobile-assigned-employee-body-row"
                    }, [
                      _createVNode("div", _hoisted_64, [
                        _createVNode("div", _hoisted_65, _toDisplayString(_ctx.$t('employees.full-name')), 1),
                        _createVNode("div", _hoisted_66, _toDisplayString(assigned.fullName), 1)
                      ]),
                      _createVNode("div", _hoisted_67, [
                        _createVNode("div", _hoisted_68, _toDisplayString(_ctx.$t('label.mobile')), 1),
                        _createVNode("div", _hoisted_69, [
                          (assigned.mobile)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                href: `tel:${assigned.mobile}`
                              }, _toDisplayString(_ctx.formatMobile(assigned.mobile)), 9, ["href"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (!_ctx.isViewMode)
                        ? (_openBlock(), _createBlock("div", _hoisted_70, [
                            _createVNode("button", {
                              onClick: ($event: any) => (_ctx.unassignEmployee(assigned.id)),
                              class: "unassignEmployee-mobile",
                              type: "button"
                            }, [
                              _hoisted_71,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('button.remove')), 1)
                            ], 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["isOpen"]))
})